import src from "IMAGE";
export default { src, width: 62, height: 486, blurWidth: 0, blurHeight: 0};
